import { APP_INITIALIZER } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { LoggerService } from '../services/logger.service';
import { HandlebarsHelpersService } from '../services/handlebars-helpers.service';

export function initializeAuth(authService: AuthService, logger: LoggerService): () => Promise<void> {
  return () => {
    logger.debug('AppInitializer', 'initializeAuth', 'Loading auth session...');
    return authService.initializeAuth();
  };
}

export function initializeHandlebars(handlebarsHelpers: HandlebarsHelpersService): () => void {
  return () => {
    // Handlebars helpers are registered in the service constructor
    // This just ensures the service is instantiated early
  };
}

export const authInitializerProvider = {
  provide: APP_INITIALIZER,
  useFactory: initializeAuth,
  deps: [AuthService, LoggerService],
  multi: true
};

export const handlebarsInitializerProvider = {
  provide: APP_INITIALIZER,
  useFactory: initializeHandlebars,
  deps: [HandlebarsHelpersService],
  multi: true
};